import { InvoiceDiscrepanciesService } from './invoiceDiscrepancies';

export const InvoiceDiscrepanciesServiceSingleton = new InvoiceDiscrepanciesService();
